/**
 * Renderizza una stringa HTML che contiene solo <mark> (sanitizzata lato server).
 * Wrapper esplicito: l'unico punto del client che usa dangerouslySetInnerHTML.
 */
export function Highlight({ html, className }: { html: string; className?: string }) {
  return <span className={className} dangerouslySetInnerHTML={{ __html: html }} />;
}
